import api from './api';
import { getToken, setTokenOffSession } from '../services/storage';

api.interceptors.request.use(
  config => {
    const token = getToken();
    const configInterceptor = { ...config };

    if (configInterceptor.url?.startsWith('/api/')) {
      configInterceptor.url = process.env.REACT_APP_BASE_URL.concat(configInterceptor.url);
    }

    if (token && config.url !== '/api/auth/local') {
      configInterceptor.headers.Authorization = `Bearer ${token}`;
    } else if (config.url !== '/api/auth/local') {
      // Avisar apenas se não for rota de autenticação
      console.warn('⚠️ [apiInterceptors] Token não adicionado. Token:', !!token, 'URL:', config.url);
    }

    return configInterceptor;
  },
  error => {
    console.error('❌ [apiInterceptors.js] ~ [request] ~ ERRO NO INTERCEPTOR DE REQUEST:', error);
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    console.error('❌ [apiInterceptors.js] ~ [response] ~ ERRO DE RESPOSTA:', error);

    return new Promise((resolve, reject) => {
      if (error.response?.status === 401) {
        console.warn('⚠️ [apiInterceptors] Sessão inválida, redirecionando para login');
        setTokenOffSession();
        window.location = '/login';
      } else if (error.response?.status === 403) {
        console.warn('⚠️ [apiInterceptors] Acesso negado (403):', error.config?.url);
      } else if (error.response?.status === 422) {
        console.warn('⚠️ [apiInterceptors] Erro 422 - Entidade não processável:', {
          url: error.config?.url,
          data: error.response?.data,
          message: error.response?.data?.message || 'Dados inválidos',
        });
      } else if (error.response?.status >= 500 && !error.config?.silent) {
        // `silent: true` na config da requisição suprime o modal global (ex.: camadas de mapa,
        // que devem falhar sem interromper o usuário).
        console.error('🚨 [apiInterceptors] Erro interno do servidor:', {
          status: error.response?.status,
          url: error.config?.url,
          message: error.response?.data?.message || 'Erro interno',
        });
        window.dispatchEvent(
          new CustomEvent('api:error', {
            detail: { status: error.response.status, message: 'Erro interno no servidor. Tente novamente mais tarde.' },
          })
        );
      }
      reject(error);
    });
  }
);
